// router/index.js
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/eli',
    name: 'eli',
    component: () => import('../views/element/ElementView.vue')
  },
  {
    path: '/chart',
    name: 'chart',
    component: () => import('../views/element/echartsCopy.vue')
  },
  {
    path: '/atlas',
    redirect: { path: '/chart', query: { tab: '6' } }
  },
]

const router = new VueRouter({
  mode: 'history', 
  routes
})

export default router